import { render, staticRenderFns } from "./SlidesPopup.vue?vue&type=template&id=47f12b07&scoped=true&"
import script from "./SlidesPopup.vue?vue&type=script&lang=js&"
export * from "./SlidesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlidesPopup.vue?vue&type=style&index=0&id=47f12b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f12b07",
  null
  
)

export default component.exports